import { FilterObjectBuilder } from './filter-object-builder';
import { keys, omit } from 'lodash';

export class ApiGetParamBuilder {

    filter: FilterObjectBuilder = new FilterObjectBuilder();
    sort: SortParamBuilder = new SortParamBuilder();

    paging: PagingBuiler = new PagingBuiler();

    constructor() {

    }

    build(): any {
        let params = {
            ...this.filter.apiFilter(),
            ...this.sort.apiSort(),
            ...this.paging.apiPaging()
        };

        keys(params)
            .forEach((key: string) => {
                if (params[key] === undefined) {
                    params = omit(params, key);
                }
            });
        return params;
    }
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',

    NONE = ''
}

export class SortParam {
    active: string;
    direction: SortDirection;

    constructor() {
        this.active = undefined;
        this.direction = undefined;
    }
}

export class SortParamBuilder {
    private sortParam: SortParam;

    constructor() {
        this.sortParam = new SortParam();
    }

    hasParam(): boolean {
        return this.sortParam.active !== undefined && this.sortParam.active !== '' && this.sortParam.direction !== '';
    }

    by(field: string, direction: SortDirection): SortParamBuilder {
        this.sortParam.active = field;
        this.sortParam.direction = direction;
        return this;
    }

    apiSort(): any {
        return {
            sort: this.hasParam() ? (this.sortParam.direction === SortDirection.ASC ? '+' + this.sortParam.active : '-' + this.sortParam.active) : undefined
        };
    }
}

export class PagingOption {
    pgSize: number;
    pg = 1;
    constructor() {}
}

export class PagingBuiler {

    private pagingParam: PagingOption;
    constructor() {
        this.pagingParam = new PagingOption();
    }

    get pagingParamValue(): PagingOption {
        return this.pagingParam;
    }

    page(pageSize: number, page: number): PagingBuiler {
        this.pagingParam.pg = page;
        this.pagingParam.pgSize = pageSize;
        return this;
    }

    apiPaging(): any {
        return {
            pg: this.pagingParam.pg + 1,
            pgsize: this.pagingParam.pgSize
        };
    }
}
